<template>
    <div class="icon-wrapper direct-messages-icon-wrapper tooltip-trigger">
        <span class="btn-direct-messages" @click="expandDirectMessages()">
            <fa-icon icon="comments" />
        </span>
        <tooltip value="Direct messages" />
        <span class="new-message-notification" v-if="allUnreadMessages.length && !directMessagesExpanded">
        </span>
    </div>
</template>

<script>
import { getAllUnreadMessages } from '../DirectMessagesWidget/DirectMessagesWidget-helpers';

export default {
    computed: {
        allUnreadMessages() {
            return getAllUnreadMessages(this.conversations, this.userId, this.username);
        },
        conversations() {
            return this.$store.state.directMessagesState.conversations;
        },
        directMessagesExpanded() {
            return this.$store.state.directMessagesState.expanded;
        },
        userId() {
            return this.$store.state.loginState.userId;
        },
        username() {
            return this.$store.state.loginState.username;
        },
    },
    methods: {
        expandDirectMessages() {
            this.$store.dispatch('setExpandedDirectMessages', true);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .direct-messages-icon-wrapper {
        cursor: pointer;
        display: inline-block;
        margin-left: 0;
        position: relative;

        .new-message-notification {
            background: $lancer;
            height: 9px;
            width: 9px;
            border-radius: 50%;
            position: absolute;
            right: -2px;
            top: -2px;

            &:before {
                animation: pulse linear 2s 4 forwards;
                background-color: transparent;
                border-radius: 50%;
                box-shadow:0px 0px 2px 2px $lancer;
                content: '';
                height: 9px;
                left: 0;
                position:absolute;
                top: 0;
                width: 9px;
            }
        }
    }

</style>
